import React from 'react';

import { FormattedMessage } from 'react-intl';

import { PATHS } from 'constants/pathsB2c';

import { StyledContainer, StyledMessage } from './NoOfferMessage.style';
import { OfferLink } from '../../Message.style';

const NoOfferMessage: React.FC<object> = () => (
  <StyledContainer>
    <StyledMessage>
      <FormattedMessage id='no-offer-message.message' />
    </StyledMessage>
    <OfferLink to={PATHS.BAM_ONLINE_OFFERS} translationId='no-offer-message.see-offers' />
  </StyledContainer>
);

export default NoOfferMessage;
